export const contactTlbItemFields = `
    id
    userId
    isActiveCrew
    aircraftVisiblityLimitations
    fullReadAccessToAircrafts
    crewId
    hasDutyTracking
    deleted
    name
    baseAirportIcaos
    isReservationResource
`;

export const contactItemFields = `
    id
    userId
    isActiveCrew
    aircraftVisiblityLimitations
    fullReadAccessToAircrafts
    crewId
    hasDutyTracking
    deleted
    nameOfficialFirst
    nameOfficialLast
    name
    isReservationResource
    avinodeId
    isCustomer
    calendarId
    skipRosterCalendarSync
    baseAirportIcaos
    dispatchGroup
    accessRights
`;
